import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CheckerComments, ValidationLevel } from '../../core/types';
import { displayString } from '../../core/utils';
import { AUTH_CONTEXT, CONFIRM_SERVICE, PROJECT_PROVIDER, VALIDATION_SERVICE, PROJECT_ROLES_CONFIG } from '../../core/tokens';
import { ControlsIconsModule } from '../icons.module';
import { CommentsComponent } from './comments.component';

@Component({
	standalone: true,
	imports: [CommonModule, ControlsIconsModule, CommentsComponent],
	selector: 'wd-comments-modal',
	templateUrl: './comments-modal.component.html',
	styleUrls: ['./comments-modal.component.css'],
})
export class CommentsModalComponent {
	@Input() name!: string;
	@Input() comments!: CheckerComments;

	displayString = displayString;
	VL = ValidationLevel;

	activeModal = inject(NgbActiveModal);
	private confirmService = inject(CONFIRM_SERVICE);
	private auth = inject(AUTH_CONTEXT);
	private ps = inject(PROJECT_PROVIDER);
	public vs = inject(VALIDATION_SERVICE);
	private rolesConfig = inject(PROJECT_ROLES_CONFIG);

	canChangeSeverity() {
		if (this.comments.resolved)
			return false;
		if (!this.ps.amIMember())
			return false;
		if (this.rolesConfig.commentNoSeverityRoles.some(r => this.ps.amI(r)))
			return false;

		return true;
	}

	canResolve() {
		return this.rolesConfig.commentReviewerRoles.some(r => this.ps.amI(r));
	}

	canDelete() {
		// Nicht löschen wenn bereits geantwortet wurde (mehr als 1 Kommentar)
		if (this.comments.comments && this.comments.comments.length > 1) {
			return false;
		}
		return this.rolesConfig.commentReviewerRoles.some(r => this.ps.amI(r));
	}

	onResolve() {
		this.comments.resolved = !this.comments.resolved;
	}

	async onDelete() {
		const confirmed = await this.confirmService.confirmDelete(
			`Sollen sämtliche Kommentare für ${this.name} wirklich gelöscht werden?`
		);
		if (confirmed) {
			// clearComments() speichert automatisch über saveContext()
			this.activeModal.close();
		}
	}

	onClose() {
		// resetComments() speichert automatisch über saveContext()
		this.vs.resetComments(this.name, this.comments);
		// 'saved' signalisiert dass bereits gespeichert wurde
		this.activeModal.close('saved');
	}
}
